import type { Locale } from "@/lib/i18n";
import { pl, type WContactFormTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wContactFormTranslations: Record<Locale, WContactFormTranslations> = {
  pl,
  en,
  de,
};

export type { WContactFormTranslations };
